import * as React from 'react';
import { observer } from "mobx-react";

import NavSidebar from "./NavSidebar/NavSidebar";

type LayoutProps = {
    children?: React.ReactNode;
};

@observer
export class Layout extends React.Component<LayoutProps, {}> {
    public render() {
        return (
            <div className="layout">
                <NavSidebar />

                <div className="base-content">
                    {this.props.children}
                </div>
            </div>
        );
    }
}